module.exports = __webpack_public_path__ + "0f20328772c0d84250ef397c129607fb.woff2";